import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { thunk } from "redux-thunk";
import mentorsSlice from "./slices/mentorsSlice";
import appointmentsSlice from "./slices/appointmentsSlice";
import categoriesSlice from "./slices/categoriesSlice";
import dataSlice from "./slices/updateUserData";
import notesSlice from "./slices/notesSlice";
import countriesSlice from "./slices/countriesSlice";

const persistConfig = {
  key: "root",
  storage,
};
const rootReducer = combineReducers({
  user: userSlice,
  appointments: appointmentsSlice,
  mentors: mentorsSlice,
  categories: categoriesSlice,
  updateData: dataSlice,
  countries: countriesSlice,
  notes: notesSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);
